import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';
import { campaignsKeys } from '../queryKeys';
import { READ_ONLY_QUERY_OPTIONS } from '../queryConfig';

/**
 * One promo code's uptake figures (redemptions, offices, total discount, opt-ins).
 *
 * Separate from usePromoCode rather than joined into it: the report is a
 * second request that can fail on its own (it 404s for a non-discount
 * campaign, for one), and the code's configuration should still render when
 * the numbers do not.
 */
export const usePromoCodeReport = (campaignId, { enabled = true } = {}) => {
  const { data, error, isError, isPending } = useQuery({
    queryKey: campaignsKeys.promoCodeReport(campaignId),
    queryFn: () => CampaignsService.getPromoCodeReport(campaignId),
    enabled: Boolean(campaignId) && enabled,
    ...READ_ONLY_QUERY_OPTIONS,
  });

  return { report: data ?? null, isPending, isError, error };
};
